import React, { useState } from "react";
import {
  AboutHeroSection,
  AboutStorySection,
  OurHeart,
  OurImpact,
  OurTarget,
} from "../components";
import { subscribeToNewsletter } from "../utils/brevoSubscribe";
import { Box, Container, Input, Typography } from "@mui/material";
import CustomButton from "../components/CustomButton";

const AboutUs = () => {
  const [email, setEmail] = useState("");

  // Handling subscribe button
  const handleSubscribe = async () => {
    if (!email) return;
    const result = await subscribeToNewsletter(email);

    if (result.success) {
      alert(
        "Thanks for subscribing to our newsletter. Check your inbox for the latest update!"
      );
    } else {
      alert(`Failed to subscribe: ${result.error.message}`);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const response = await fetch(
      "https://api.hsforms.com/submissions/v3/integration/submit/143406952/0d30c480-2f47-4d19-af7c-7121c18c7aa8",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          fields: [
            {
              name: "email",
              value: email,
            },
          ],
        }),
      }
    );
    const result = await response.json();
    console.log(result);
    if (response.ok) {
      alert(
        "Thanks for subscribing to our newsletter. Check your inbox for the latest update!"
      );
    } else {
      alert(`Failed to subscribe: ${result.message || "Unknown error"}`);
    }
  };

  return (
    <>
      {/* About Hero Section */}
      <AboutHeroSection />

      {/* Who are we??? */}

      <AboutStorySection />

      <OurHeart />

      <OurTarget />

      <OurImpact />

      {/* Our team section */}
      {/* Subscribe to newsletter section */}
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "40vh",
          justifyContent: "center",
          alignItems: "center",
          mb: { xs: 5, md: 0 },
          mt: { xs: 5, md: 0 },
        }}
      >
        <Typography variant="h7">Newsletter</Typography>
        <Typography variant="h2" maxWidth={"250px"} my={4} textAlign={"center"}>
          Subscribe to <span style={{ color: "#DB5430" }}>our newsletter</span>
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "space-between",
            alignItems: "center",
            width: { xs: "100%", md: "40%" },
          }}
        >
          <Input
            variant="outlined"
            placeholder="Enter your email address"
            sx={{
              color: "#222222",
              width: { xs: "100%", md: "60%" },
              my: { xs: 2, md: 0 },
            }}
            onChange={(e) => setEmail(e.target.value)}
          />
          <CustomButton onClick={handleSubmit}>
            <Typography mx={5}>Send</Typography>
          </CustomButton>
        </Box>
      </Container>
    </>
  );
};

export default AboutUs;
